import { render, staticRenderFns } from "./dy-tip.vue?vue&type=template&id=0cfb9a87&scoped=true"
import script from "./dy-tip.vue?vue&type=script&lang=js"
export * from "./dy-tip.vue?vue&type=script&lang=js"
import style0 from "./dy-tip.vue?vue&type=style&index=0&id=0cfb9a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb9a87",
  null
  
)

export default component.exports